import './style/index.js';

import _Col from './col';
import _Row from './row';

export type { RowProps } from './row';
export type { ColProps } from './col';
export * from './type';

export const Row = _Row;
export const Col = _Col;
